import { BaseService } from '@/infrastructure/api/base.service'
import type {
  UiExperienceEvent,
  UiExperienceState,
  UiExperienceTrackResponse,
} from '../types/experience.types'

/**
 * New-UI rollout state (gate, invite, remembered choice). The server owns the
 * rules and the v2 <-> v3 page mapping; this client only reads state and
 * records events.
 */
export class ExperienceService extends BaseService {
  constructor() {
    super('')
  }

  getState(): Promise<UiExperienceState> {
    return this.get<UiExperienceState>('/V2/UiExperience/GetState')
  }

  track(event: UiExperienceEvent, fromPath: string): Promise<UiExperienceTrackResponse> {
    return this.post<UiExperienceTrackResponse>('/V2/UiExperience/Track', {
      Event: event,
      FromPath: fromPath,
    })
  }
}
